var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFichajeRecurrente({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.42578,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.42578,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_45147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 16.5508C29.742 16.5508 30.2083 17.0172 30.2083 17.5924V18.6341H32.2917C33.4423 18.6341 34.375 19.5669 34.375 20.7174V33.2174C34.375 34.3681 33.4423 35.3008 32.2917 35.3008H17.7083C16.5577 35.3008 15.625 34.3681 15.625 33.2174V20.7174C15.625 19.5669 16.5577 18.6341 17.7083 18.6341H19.7917V17.5924C19.7917 17.0172 20.258 16.5508 20.8333 16.5508C21.4086 16.5508 21.875 17.0172 21.875 17.5924V18.6341H28.125V17.5924C28.125 17.0172 28.5914 16.5508 29.1667 16.5508ZM32.2917 20.7174H17.7083V33.2174H32.2917V20.7174ZM27.9418 23.1953C28.3485 22.7885 29.0081 22.7885 29.4149 23.1953C29.8218 23.6021 29.8218 24.2616 29.4149 24.6684L24.2664 29.817C23.8554 30.2279 23.1893 30.2279 22.7784 29.817L20.5761 27.6147C20.1693 27.2079 20.1693 26.5484 20.5761 26.1415C20.9829 25.7347 21.6424 25.7347 22.0492 26.1415L23.5224 27.6147L27.9418 23.1953Z",
    fill: "#4F5660"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_45147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(12.5 13.4258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFichajeRecurrente);
export default __webpack_public_path__ + "static/media/fichajeRecurrente.fec2cf4289354e75ebeffee93500b56f.svg";
export { ForwardRef as ReactComponent };